/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../types/schema.generated';

import gql from 'graphql-tag';
import { DefaultAppHeaderQueryFragmentDoc } from '../components/organisms/AppHeader/AppHeader.generated';
import { AppFooterFragmentDoc } from '../components/organisms/AppFooter/AppFooter.generated';
import { ModalManagerContractFragmentDoc, ModalManagerViewerFragmentDoc } from './ModalManager.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ContractType =
  | 'CORPORATE'
  | 'INDIVIDUAL'
  | 'UNKNOWN';

export type PaymentMethod =
  | 'STRIPE'
  | 'UNKNOWN';

export type TermType =
  /** プライバシーポリシー */
  | 'PRIVACY_POLICY'
  /** 通信の秘密 */
  | 'SECRECY_OF_COMMUNICATIONS'
  /** 利用規約 */
  | 'TERMS_OF_SERVICE';

export type FetchDefaultLayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDefaultLayoutQuery = { viewer: { id: string, profile: { name: string, avatar: any }, staff: { email: string }, requiredAgreementTerms: Array<{ id: string, type: Types.TermType, title: string, body: MarkdownString }> }, contract: { contractType: Types.ContractType, paymentMethod: Types.PaymentMethod, isCreditCardAvailable: boolean } | null, terms: Array<{ type: Types.TermType, title: string }> };


export const FetchDefaultLayoutDocument = gql`
    query FetchDefaultLayout {
  ...DefaultAppHeaderQuery
  ...AppFooter
  viewer {
    ...ModalManagerViewer
  }
  contract {
    ...ModalManagerContract
  }
}
    ${DefaultAppHeaderQueryFragmentDoc}
${AppFooterFragmentDoc}
${ModalManagerViewerFragmentDoc}
${ModalManagerContractFragmentDoc}`;

/**
 * __useFetchDefaultLayoutQuery__
 *
 * To run a query within a Vue component, call `useFetchDefaultLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDefaultLayoutQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchDefaultLayoutQuery();
 */
export function useFetchDefaultLayoutQuery(options: VueApolloComposable.UseQueryOptions<FetchDefaultLayoutQuery, FetchDefaultLayoutQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchDefaultLayoutQuery, FetchDefaultLayoutQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchDefaultLayoutQuery, FetchDefaultLayoutQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchDefaultLayoutQuery, FetchDefaultLayoutQueryVariables>(FetchDefaultLayoutDocument, {}, options);
}
export function useFetchDefaultLayoutLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchDefaultLayoutQuery, FetchDefaultLayoutQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchDefaultLayoutQuery, FetchDefaultLayoutQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchDefaultLayoutQuery, FetchDefaultLayoutQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchDefaultLayoutQuery, FetchDefaultLayoutQueryVariables>(FetchDefaultLayoutDocument, {}, options);
}
export type FetchDefaultLayoutQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchDefaultLayoutQuery, FetchDefaultLayoutQueryVariables>;